var map = {
	"./all-data-bg.svg": "a241",
	"./bg-dots-1.svg": "2250",
	"./bg-dots-2.svg": "9da4",
	"./bg-dots-3.svg": "2c3a",
	"./capabilities/block-1.svg": "fc32",
	"./capabilities/block-2.svg": "d53d",
	"./capabilities/block-3.svg": "b92b",
	"./capabilities/block-4.svg": "3414",
	"./capabilities/block-5.svg": "db37",
	"./capabilities/block-6.svg": "e2f3",
	"./capabilities/block-7.svg": "417b",
	"./capabilities/icon-1.svg": "b345",
	"./capabilities/icon-2.svg": "0357",
	"./capabilities/icon-3.svg": "6e3c",
	"./capabilities/icon-4.svg": "64c8",
	"./capabilities/icon-5.svg": "8779",
	"./capabilities/icon-6.svg": "99fb",
	"./capabilities/icon-7.svg": "303d",
	"./contacts/office_msk.png": "fdc9",
	"./cost-dots-mobile.svg": "5a7f",
	"./cost-dots.svg": "1777",
	"./cost.svg": "9b70",
	"./dataforce-block-bg-bottom.svg": "31ab",
	"./dataforce-block-bg-right-mobile.svg": "6ee2",
	"./dataforce-block-bg-right.svg": "98c7",
	"./dataforce-by-seowork.svg": "ccd8",
	"./fasie_logo.png": "1a9f",
	"./feature-item-1.svg": "774f",
	"./feature-item-2.svg": "7481",
	"./feature-item-3.svg": "d3e4",
	"./form-bg-1.svg": "76f1",
	"./form-bg-2.svg": "53e2",
	"./form-bg-3.svg": "fb4f",
	"./how-it-works-1.svg": "4be3",
	"./how-it-works-2.svg": "639c",
	"./how-it-works-3.svg": "2772",
	"./how-it-works-4.svg": "4bf0",
	"./how-it-works-5.svg": "2490",
	"./how-it-works-6.svg": "da16",
	"./how-it-works-7.svg": "53ba",
	"./icons/analytic.svg": "76f8",
	"./icons/ceo.svg": "6d72",
	"./icons/marketer.svg": "0387",
	"./icons/product.svg": "226e",
	"./icons/specialist.svg": "4445",
	"./index-bg-1.svg": "3c18",
	"./index-bg-2.svg": "ad23",
	"./index-preview-mobile.svg": "e607",
	"./index-preview.svg": "ab0e",
	"./logo.svg": "3016",
	"./main-preview.svg": "19ad",
	"./partners/auchan.svg": "0d23",
	"./partners/citylink.svg": "67ae",
	"./partners/eldorado.svg": "74f9",
	"./partners/farfetch.svg": "a523",
	"./partners/lenta.svg": "bdc2",
	"./partners/ozon.svg": "e654",
	"./partners/petrovich.svg": "c056",
	"./partners/sber.svg": "5f82",
	"./partners/vse_instrumenti.svg": "77fe",
	"./publications/publication-1.svg": "ff58",
	"./publications/publication-2.svg": "fb9d",
	"./publications/publication-3.svg": "617a",
	"./screen.svg": "389b",
	"./seowork-screen.svg": "2c2a",
	"./skolkovo.png": "7bff",
	"./slider-bg-1.svg": "efc8",
	"./slider-bg-2.svg": "9fca",
	"./team/certificate_1.jpeg": "ae48",
	"./team/certificate_2.jpeg": "f604",
	"./team/dots.svg": "a1b7",
	"./team/stas-main-io.jpg": "f3337",
	"./team/stas-main.jpg": "fb6d",
	"./team/stas-main.webp": "98e1",
	"./team/stas-main_320.jpg": "e5fd",
	"./team/stas-main_320.webp": "36ff",
	"./team/stas-main_480.jpg": "ad7a",
	"./team/stas-main_480.webp": "3e32",
	"./team/stas-main_768.jpg": "302e",
	"./team/stas-main_768.webp": "a8c0",
	"./team/stas.png": "242a",
	"./team/today.png": "bab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d957";